import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BabyCare = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // BabyCare Blue Theme Activation
    document.body.className = "babycare-page";
    return () => {
      document.body.className = "";
    };
  }, []);

  // Common Redirect function for Premium Features
  const goToPremium = () => {
    navigate("/floracare-plus");
  };

  return (
    <main>
      {/* Header Section */}
      <section className="page-title-section">
        <div className="container">
          <h1>
            <i className="fas fa-baby"></i> BabyCare Hub
          </h1>
          <p>
            Track milestones and ensure your baby's safety with our expert
            guides.
          </p>
        </div>
      </section>

      <div className="container" style={{ padding: "3rem 2rem" }}>
        <div className="dashboard-grid">
          {/* 1. Vaccination Tracker (Redirects to Premium) */}
          <div
            className="card card-highlight"
            onClick={goToPremium}
            style={{ cursor: "pointer" }}
          >
            <div className="card-icon">
              <i className="fas fa-syringe"></i>
            </div>
            <h3>Vaccination Tracker</h3>
            <p>Access personalized immunization schedules and reminders.</p>
            <span className="badge">Premium Feature</span>
            <div
              style={{
                marginTop: "1rem",
                fontSize: "0.85rem",
                fontWeight: "bold",
              }}
            >
              View Schedule in FloraCare+ →
            </div>
          </div>

          {/* 2. Growth Milestones (Now also Redirects to Premium) */}
          <div
            className="card card-highlight"
            onClick={goToPremium}
            style={{ cursor: "pointer" }}
          >
            <div className="card-icon">
              <i className="fas fa-chart-line"></i>
            </div>
            <h3>Growth Milestones</h3>
            <p>
              Track height, weight, and developmental progress month-by-month.
            </p>
            <span className="badge">Premium Feature</span>
            <div
              style={{
                marginTop: "1rem",
                fontSize: "0.85rem",
                fontWeight: "bold",
              }}
            >
              Unlock Tracker in FloraCare+ →
            </div>
          </div>
        </div>

        {/* 🛡️ Baby Safety Articles (Accessible to everyone) */}
        <section style={{ marginTop: "4rem" }}>
          <h2 style={{ textAlign: "center", marginBottom: "2.5rem" }}>
            <i className="fas fa-shield-alt"></i> Essential Safety Articles
          </h2>

          <div className="specialty-cards">
            <article className="card">
              <div className="card-icon" style={{ color: "#ff9800" }}>
                <i className="fas fa-home"></i>
              </div>
              <h3>Home Proofing 101</h3>
              <p>
                Essential steps to baby-proof your living space as your little
                one starts crawling.
              </p>
              <button
                className="btn btn-outline btn-small"
                style={{ marginTop: "auto" }}
              >
                Read Article
              </button>
            </article>

            <article className="card">
              <div className="card-icon" style={{ color: "#2196f3" }}>
                <i className="fas fa-bed"></i>
              </div>
              <h3>Safe Sleep Guide</h3>
              <p>
                Everything you need to know about crib safety and SIDS
                prevention.
              </p>
              <button
                className="btn btn-outline btn-small"
                style={{ marginTop: "auto" }}
              >
                Read Article
              </button>
            </article>

            <article className="card">
              <div className="card-icon" style={{ color: "#f44336" }}>
                <i className="fas fa-first-aid"></i>
              </div>
              <h3>First Aid Basics</h3>
              <p>
                Key first aid tips every parent should know for common infant
                emergencies.
              </p>
              <button
                className="btn btn-outline btn-small"
                style={{ marginTop: "auto" }}
              >
                Read Article
              </button>
            </article>
          </div>
        </section>
      </div>
    </main>
  );
};

export default BabyCare;
